if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaItems = [];
        this.currentIndex = 0;
        this.startX = 0;
        this.isDragging = false;
        this.isNavigating = false;
      }

      connectedCallback() {
        super.connectedCallback?.();
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        
        if (this.prevButton && this.nextButton) {
          this.prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.isNavigating) return;
            this.syncCurrentIndex();
            this.navigate(-1);
          });
          this.nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.isNavigating) return;
            this.syncCurrentIndex();
            this.navigate(1);
          });
        }

        this.setupDragNavigation();
      }

      setupDragNavigation() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;

        content.addEventListener('touchstart', (e) => {
          this.startX = e.touches[0].clientX;
          this.isDragging = true;
          this.syncCurrentIndex();
        }, { passive: true });

        content.addEventListener('touchmove', (e) => {
          if (!this.isDragging) return;
        }, { passive: true });

        content.addEventListener('touchend', (e) => {
          if (!this.isDragging) return;
          
          const endX = e.changedTouches[0].clientX;
          const diffX = this.startX - endX;
          
          if (Math.abs(diffX) > 50) {
            if (diffX > 0) {
              this.navigate(1);
            } else {
              this.navigate(-1);
            }
          }
          
          this.isDragging = false;
        });

        content.addEventListener('mousedown', (e) => {
          this.startX = e.clientX;
          this.isDragging = true;
          this.syncCurrentIndex();
          e.preventDefault();
        });

        content.addEventListener('mousemove', (e) => {
          if (!this.isDragging) return;
        });

        content.addEventListener('mouseup', (e) => {
          if (!this.isDragging) return;
          
          const endX = e.clientX;
          const diffX = this.startX - endX;
          
          if (Math.abs(diffX) > 50) {
            if (diffX > 0) {
              this.navigate(1);
            } else {
              this.navigate(-1);
            }
          }
          
          this.isDragging = false;
        });

        content.addEventListener('mouseleave', () => {
          this.isDragging = false;
        });
      }

      syncCurrentIndex() {
        const activeMedia = this.querySelector('[data-media-id].active');
        if (activeMedia && this.mediaItems.length > 0) {
          const newIndex = this.mediaItems.indexOf(activeMedia);
          if (newIndex !== -1) {
            this.currentIndex = newIndex;
          }
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initializeNavigation();
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      initializeNavigation() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        
        // Get only direct children of content that have data-media-id
        const allMediaItems = Array.from(content.children).filter(child => 
          child.hasAttribute('data-media-id')
        );
        
        // Remove duplicates based on data-media-id
        const seenIds = new Set();
        this.mediaItems = allMediaItems.filter(item => {
          const mediaId = item.getAttribute('data-media-id');
          if (seenIds.has(mediaId)) {
            return false;
          }
          seenIds.add(mediaId);
          return true;
        });
        
        const activeMedia = this.querySelector('[data-media-id].active');
        
        if (activeMedia) {
          this.currentIndex = this.mediaItems.indexOf(activeMedia);
        }
        
        this.updateNavigationButtons();
      }

      navigate(direction) {
        if (this.mediaItems.length === 0 || this.isNavigating) return;
        
        this.isNavigating = true;
        
        this.currentIndex += direction;

        if (this.currentIndex < 0) {
          this.currentIndex = this.mediaItems.length - 1;
        } else if (this.currentIndex >= this.mediaItems.length) {
          this.currentIndex = 0;
        }

        this.showMediaAtIndex(this.currentIndex);
        
        setTimeout(() => {
          this.isNavigating = false;
        }, 300);
      }

      showMediaAtIndex(index) {
        const targetMedia = this.mediaItems[index];
        if (!targetMedia) return;

        this.mediaItems.forEach((item) => {
          item.classList.remove('active');
        });

        targetMedia.classList.add('active');
        targetMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        const template = targetMedia.querySelector('template');
        const content = template ? template.content : null;
        
        if (targetMedia.nodeName == 'DEFERRED-MEDIA' && content && content.querySelector('.js-youtube')) {
          targetMedia.loadContent();
        }

        this.updateNavigationButtons();
      }

      updateNavigationButtons() {
        if (!this.prevButton || !this.nextButton) return;
        
        if (this.mediaItems.length <= 1) {
          this.prevButton.style.display = 'none';
          this.nextButton.style.display = 'none';
        } else {
          this.prevButton.style.display = 'flex';
          this.nextButton.style.display = 'flex';
        }
      }
    }
  );
}
